import { setFulfilled, setPending, setRejected } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { NetworkThemeSummaryLoadAction } from '../../domains/networkThemeSummary/actions.types';

import { NetworkThemeSummaryLifecycle } from './types';

const initialState: NetworkThemeSummaryLifecycle = {
  fulfilled: undefined,
  rejected: undefined,
  pending: false,
};

const reducer: Reducer<NetworkThemeSummaryLifecycle, NetworkThemeSummaryLoadAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case 'NETWORK_THEME_SUMMARY.LOAD_PENDING':
      return setPending();
    case 'NETWORK_THEME_SUMMARY.LOAD_FULFILLED':
      return setFulfilled(action.payload.entities.networkThemeSummary);
    case 'NETWORK_THEME_SUMMARY.LOAD_REJECTED':
      return setRejected(action.payload.error);
    default:
      return state;
  }
};

export default reducer;
